import './Badge.css';
import Text from './Text';
import React from 'react';

export default function Badge(
  {
    label,
    style
  }: {
    label: string;
    style?: React.CSSProperties;
  }
) {
  return (
    <Text
      color='grey'
      className='Badge'
      style={style}
    >
      {label}
    </Text>
  );
}